var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-100-vh"},[(_vm.orderId != null)?_c('OrderComponent',{attrs:{"orderId":_vm.orderId}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }